
import {Controller, type Control} from "react-hook-form";
import { CaUserAcademy } from "../../../../types/dto/program";
import { Input } from "../../../../shared/components/ui/form/inputs";

export default function StudentForm({control}: {control: Control<CaUserAcademy>}) {
  
  return (
    <div className="flex flex-col gap-2">
      <Controller
        control={control}
        name="email"
        render={({field, fieldState}) => (
          <div>
            {fieldState.error ? (
              <span className="mt-1 block text-xs text-red-500">{fieldState.error.message}</span>
            ) : null}
          </div>
        )}
      />
      <Input style={{background:'none'}} control={control} label="Nombre" name="first_name" />
      <Input style={{background:'none'}} control={control} label="Apellido" name="last_name" />
      <Input style={{background:'none'}} control={control} label="Email" name="email" />
      <Input style={{background:'none'}} control={control} label="Teléfono" name="phone" />
      <Input style={{background:'none'}} control={control} label="Código estudiantil" name="student_code" />
    </div>
  );
}
